import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import classNames from "classnames";

import { useRootAppStore } from "@hooks";
import { Button } from "@components/buttons";
import CustomMessagePreview from "./CustomMessagePreview";
import useReplyMessage from "../shared/useReplyMessage";
import { ChatReplyMessagePreview } from ".";
import { checkIfMessageIsLink } from "@utils/chat";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";
import { SupportChatInfoBox } from "../shared";

export default observer(function SendMessage() {
	const { chatViewStore } = useRootAppStore();
	const [inputValue, setInputValue] = useState<string>("");

	const [isReadonly, setIsReadonly] = useState(false);

	const { t } = useTranslation();

	const shouldDisableSubmit =
		chatViewStore.messageSendingLoader ||
		((!inputValue || inputValue.trim().length == 0) &&
			!chatViewStore.sharedBetSlipData);

	const { replyScrollingLoader } = chatViewStore;

	const isLink = checkIfMessageIsLink(inputValue);

	const replyingMessage = useReplyMessage(inputValue, isLink);

	const sendMsg = async (e: any) => {
		e.preventDefault();

		const isLink = checkIfMessageIsLink(inputValue);

		document.getElementById("chat-textarea")?.focus();

		if (!chatViewStore.selectedMessageToReplyOn) {
			chatViewStore.chatChannelHandler.sendMessage(
				inputValue,
				isLink,
				chatViewStore.sharedBetSlipData?.hasBetBuilder
			);
		} else if (replyingMessage) {
			chatViewStore.chatChannelHandler.replyToMessage(replyingMessage);
		}
		setInputValue("");
	};

	const handleTextAreaSubmit = (
		e: React.KeyboardEvent<HTMLTextAreaElement>
	) => {
		const event = new KeyboardEvent("keydown", {
			key: "Enter",
			code: "Enter",
			which: 13,
			keyCode: 13,
		});
		if (e.key == "Enter") {
			document.getElementById("chat-textarea")?.dispatchEvent(event);
		}
	};

	const handleFocus = () => {
		document.querySelector(".l--master")?.classList.add("keyboard-open");
	};
	const handleBlur = () => {
		document.querySelector(".l--master")?.classList.remove("keyboard-open");
	};

	useEffect(() => {
		return handleBlur;
	}, []);

	return (
		<ErrorBoundaryWithPropagation componentName={"Mobile/SendMessage.tsx"}>
			<form
				className={classNames("chat__footer", {
					"chat__footer--scrolling": replyScrollingLoader,
				})}
				onSubmit={sendMsg}
				aria-disabled={replyScrollingLoader}
			>
				<SupportChatInfoBox store={chatViewStore} />
				<ChatReplyMessagePreview />

				<CustomMessagePreview
					isMultiOffer={
						chatViewStore.sharedBetSlipData?.hasBetBuilder
					}
				/>
				<div className="chat__textbox">
					<textarea
						maxLength={10000}
						id="chat-textarea"
						onKeyDown={handleTextAreaSubmit}
						rows={3}
						value={inputValue}
						className="chat__textarea input input--base input--textarea"
						placeholder={t("CHAT.ENTER_MESSAGE")}
						onChange={(e) => setInputValue(e.target.value)}
						disabled={replyScrollingLoader}
						readOnly={isReadonly}
						onFocus={handleFocus}
						onBlur={handleBlur}
						autoFocus
					></textarea>

					<Button
						id="send_message_button"
						className="chat__send btn btn--square btn--square--sml btn--icon btn--accent"
						iconClassName="u-icon u-icon--sml u-icon--arrow--send u-color--accent--text"
						iconOnly
						disabled={shouldDisableSubmit}
					/>
				</div>
			</form>
		</ErrorBoundaryWithPropagation>
	);
});
